import { makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';
import SidebarIcon from '../../assets/svg/sidebar.svg';
import ChatCompose from './ChatCompose';

const useStyles = makeStyles((theme) => ({
    list: {
        width: 300,
        background: themes.palette.primary.light,
        display: 'flex',
        // overflowY: 'auto',
        justifyContent: 'space-between',
        flexDirection: 'column',
        padding: '0 24px',
    },
    logo: {
        width: '69px',
        // margin: '40px auto',
    },
    styleQuizIconContainer: {
        height: '30px',
        width: '30px',
    },
    sidebarIcon: {
        height: '22px',
        width: '22px',
    },
}));
export default function ChatSidebarHeader({ handleNewConversation }) {
    const classes = useStyles();
    return (
        <div className="header-container">
            <div>
                <img src={SidebarIcon} alt="sidebar" className={classes.sidebarIcon} />
            </div>
            <div className={classes.styleQuizIconContainer}>
                <ChatCompose handleNewConversation={handleNewConversation} />
            </div>
        </div>
    );
}
